import { useSyncExternalStore } from 'react'
import { create } from 'zustand'

const KEY_SIDE_NAV_COLLAPSED = 'side_nav_collapsed'
const EXPAND_BY_DEFAULT_MIN_WIDTH = 1280

const readCollapsed = () => {
    try {
        const saved = localStorage.getItem(KEY_SIDE_NAV_COLLAPSED)
        if (saved !== null) return saved === 'true'
    } catch {
        // 저장소를 못 읽으면 화면 폭으로 정한다
    }
    return window.innerWidth < EXPAND_BY_DEFAULT_MIN_WIDTH
}

const saveCollapsed = (collapsed: boolean) => {
    try {
        localStorage.setItem(KEY_SIDE_NAV_COLLAPSED, String(collapsed))
    } catch {
        // 저장이 막혀도 지금 화면에는 적용한다
    }
}

interface ISideNavStore {
    /** 1024px 이상: 레일(72)로 접었는지 */
    isCollapsed: boolean
    /** 1023px 이하 서랍 */
    isDrawerOpen: boolean
    toggleCollapsed: () => void
    toggleDrawer: () => void
    closeDrawer: () => void
}

export const useSideNavStore = create<ISideNavStore>()((set, get) => ({
    isCollapsed: readCollapsed(),
    isDrawerOpen: false,
    toggleCollapsed: () => {
        const collapsed = !get().isCollapsed
        saveCollapsed(collapsed)
        set({ isCollapsed: collapsed })
    },
    toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
    closeDrawer: () => set({ isDrawerOpen: false })
}))

/** tailwind `md` 와 같은 경계 */
const DRAWER_QUERY = '(max-width: 1023px)'
/** tailwind `sm` 과 같은 경계 */
const MOBILE_QUERY = '(max-width: 599px)'

export const isDrawerWidth = () => window.matchMedia(DRAWER_QUERY).matches

const subscribeQuery = (query: string) => (onChange: () => void) => {
    const list = window.matchMedia(query)
    list.addEventListener('change', onChange)
    return () => list.removeEventListener('change', onChange)
}

const subscribeDrawerWidth = subscribeQuery(DRAWER_QUERY)
const subscribeMobileWidth = subscribeQuery(MOBILE_QUERY)

export const useIsDrawerWidth = () => useSyncExternalStore(subscribeDrawerWidth, isDrawerWidth)

export const useIsMobileWidth = () =>
    useSyncExternalStore(subscribeMobileWidth, () => window.matchMedia(MOBILE_QUERY).matches)
